// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"c2d69dd1","737":"56921c9b"}[chunkId] + ".chunk.js";
};